<template>
  <div>
    <div>
      <!-- <el-input
        style="width: 200px"
        placeholder="组织结构名称"
        v-model="searchForm.name"
      ></el-input>
    <el-input
        style="width: 200px; margin-left: 10px"
        placeholder="编号"
        v-model="searchForm.code"
      ></el-input> 
      <el-date-picker
        v-model="searchForm.startTime"
        type="date"
        placeholder="开始时间"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        style="width: 200px; margin-left: 10px"
      ></el-date-picker>
      <el-date-picker
        v-model="searchForm.endTime"
        type="date"
        placeholder="结束时间"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        style="width: 200px; margin-left: 10px"
      ></el-date-picker> -->
      <el-input
        style="width: 200px; margin-left: 10px"
        placeholder="查询天数"
        v-model="searchForm.days"
        type="number"
      ></el-input>
      <el-button @click="getpage(1)" style="margin-left: 10px">筛选</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </div>
    <el-divider></el-divider>
    <div>
      <el-table :data="list">
        <el-table-column align="center" label="使用截止时间">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ scope.row.endDate }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="组织机构名称">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>名称: {{ scope.row.name }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag
                  size="medium"
                  style="cursor: pointer"
                  @click="goToOrg(scope.row)"
                >{{ scope.row.name }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column align="center" label="简称">
          <template slot-scope="scope">
            <span>{{ scope.row.shortName }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="类型">
          <template slot-scope="scope">
            <el-tag :type="getTypeTag(scope.row.type)">
              {{ getTypeName(scope.row.type) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column align="center" label="层级">
          <template slot-scope="scope">
            <span>{{ scope.row.level }}</span>
          </template>
        </el-table-column> -->

        <!-- <el-table-column align="center" label="临期提醒">
          <template slot-scope="scope">
            <span>{{ scope.row.adventReminder }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="到期提醒">
          <template slot-scope="scope">
            <span>{{ scope.row.expirationReminder }}</span>
          </template>
        </el-table-column> -->
        <el-table-column align="center" label="编号">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      @givePageIndex="getpage"
      :index="page"
      :pageSize="pageSize"
      :total="total"
    ></page>
  </div>
</template>

<script>
import page from "../../components/pages";
export default {
  components: {
    page,
  },
  mounted() {
    this.load();
  },
  data() {
    return {
      searchForm: {
        name: "",
        code: "",
        startTime: "",
        endTime: "",
        days: "",
        search: "",
      },
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
    };
  },
  methods: {
    // 获取类型名称
    getTypeName(type) {
      const typeMap = {
        0: "其他",
        1: "机构(医院)",
        2: "科室",
      };
      return typeMap[type] || "未知";
    },
    // 获取类型标签颜色
    getTypeTag(type) {
      const tagMap = {
        0: "",
        1: "success",
        2: "warning",
      };
      return tagMap[type] || "";
    },
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        name: "",
        code: "",
        startTime: "",
        endTime: "",
        days: "",
        search: "",
      };
      this.getpage(1);
    },
    // 加载数据
    load() {
      let obj = {
        pageNo: this.page,
        pageSize: this.pageSize,
        name: this.searchForm.name,
        code: this.searchForm.code,
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        days: this.searchForm.days,
        search: this.searchForm.search,
      };
      console.log(obj);
      this.$api
        .getExpiringList(obj)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
            this.list = res.data.data.records;
            this.page = res.data.data.current;
            this.pageSize = res.data.data.size;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("获取数据失败");
        });
    },
    // 分页
    getpage(x) {
      console.log(x);
      this.page = x;
      this.load();
    },
    // 跳转到组织机构页面
    goToOrg(row) {
      sessionStorage.setItem("tab", "/org");
      this.$router.push({
        path: "/org",
        query: {
          orgId: row.id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
